/* eslint-disable no-param-reassign */
import Vue from 'vue';
import Vuex from 'vuex';

import auth from './modules/auth';
import mobileNav from './modules/mobileNav';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    auth,
    mobileNav,
  },
});
